export const variationsSelector = state => state.variations.entities;
